import { FormikHelpers, useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { VideoCreate } from '../video';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  FormHelperText,
  Select,
  MenuItem,
  Paper,
  Box,
  Button,
} from '@mui/material';
import useFetchCategories from '../hooks/useFetchVideos';

type VideoProps = {
  onSubmit: (
    value: VideoCreate,
    helpers: FormikHelpers<VideoCreate>
  ) => Promise<boolean>;
  submitting: boolean;
};

const CreateVideoForm = ({ onSubmit, submitting }: VideoProps) => {
  const navigate = useNavigate();

  const handleSubmit = async (
    value: VideoCreate,
    helpers: FormikHelpers<VideoCreate>
  ) => {
    const success = await onSubmit(value, helpers);
    if (success) {
      navigate('/', { replace: true });
      navigate('/videos/create', { replace: true });
    }
  };

  const { categories } = useFetchCategories();

  const initialValues: VideoCreate = {
    title: '',
    artistName: '',
    videoId: '',
    video_category_id: '',
    youtubeImgUrl: '',
    youtubeLink: '',
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
  });

  // console.log('Edit Form', initialValues);

  return (
    <>
      <Box sx={{ flexGrow: 1, maxWidth: 800 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Grid item>
              <Paper sx={{ p: 2, pb: 3 }}>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="title"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Title"
                      placeholder=""
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.title)}
                      helperText={formik.errors.title}
                    />
                  </Grid>

                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="artistName"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Artist Name"
                      placeholder=""
                      value={formik.values.artistName}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.artistName)}
                      helperText={formik.errors.artistName}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="videoId"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Video Id"
                      placeholder=""
                      value={formik.values.videoId}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.videoId)}
                      helperText={formik.errors.videoId}
                    />
                  </Grid>

                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <FormControl
                      sx={{ minWidth: 120 }}
                      fullWidth
                      error={Boolean(formik.errors.video_category_id)}
                    >
                      <InputLabel>Video Category</InputLabel>
                      <Select
                        value={formik.values.video_category_id}
                        size="small"
                        label="Video Category"
                        onChange={formik.handleChange}
                        name="video_category_id"
                      >
                        {categories.map((category) => (
                          <MenuItem key={category.id} value={category.id}>
                            {category.title}
                          </MenuItem>
                        ))}
                      </Select>
                      {Boolean(formik.errors.video_category_id) && (
                        <FormHelperText>
                          {formik.errors.video_category_id}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="space-between"
                  spacing={1}
                  sx={{ mt: 2 }}
                >
                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="youtubeImgUrl"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Youtube Image Url"
                      placeholder=""
                      value={formik.values.youtubeImgUrl}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.youtubeImgUrl)}
                      helperText={formik.errors.youtubeImgUrl}
                    />
                  </Grid>

                  <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                    <TextField
                      fullWidth
                      name="youtubeLink"
                      size="small"
                      type="text"
                      variant="outlined"
                      label="Youtube LInk"
                      placeholder=""
                      value={formik.values.youtubeLink}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.youtubeLink)}
                      helperText={formik.errors.youtubeLink}
                    />
                  </Grid>
                </Grid>

                <Grid container sx={{ mt: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={submitting}
                    size="small"
                  >
                    {submitting ? 'Saving' : 'Save'}
                  </Button>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default CreateVideoForm;
